import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ViewInformationDialogComponent } from './parts/view-information-dialog/view-information-dialog.component';
import { TranslatePipe } from '@ngx-translate/core';
import { V2ButtonComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'admin-view-information',
  templateUrl: './view-information.component.html',
  styleUrls: ['./view-information.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [V2ButtonComponent, TranslatePipe]
})
export class ViewInformationComponent {
  private readonly matDialog = inject(MatDialog);

  readonly translationPrefix = input<string>(undefined);

  public openInformationDialog(): void {
    this.matDialog.open(ViewInformationDialogComponent, {
      width: '50vw',
      maxWidth: '2000px',
      data: { translationPrefix: this.translationPrefix() }
    });
  }
}
